// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/map-thumbnail.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_IpLxh {
 position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  flex-direction:column;
}

.loader_qpzHn {
  width: 100%;
  height: 100%;
}

.header_jNXcE {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/
}

.mapSplit_kIzBD {
  height: 100%;
}

.mapSplitLeft_LBV3z {
  height: 100%;

  & > div {
    height : 100%;
  }
}

.mapSplitRight_AXsRw {
  background-color: #F4F6FA;
  height: 100%;
  overflow-y: scroll;
}

.trash_nDGai {
  color : 'red';
}

section.thumbnails_P2q59 {
  display : grid;
  grid: auto-flow dense / 1fr 1fr 1fr;
  row-gap: 16px;
  column-gap: 32px;
  padding: 32px;
}

.geotileThumbnail_hw_L1 {
  height: 200px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 72px;

  &:hover {
    cursor: pointer;
  }

  & .geotileThumbnailBottom_tMibk {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 32px;
    grid-template-rows: 1fr 1fr;
    grid-template-areas: 
      "title delete"
      "subtitle delete";

    & .geotileThumbnailTitle_WBOoI {
      grid-area: title;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    & .geotileThumbnailSubtitle_uQBcE {
      grid-area: subtitle;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    & .delete_UjMEt {
      grid-area: delete;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  & .thumbnailImage_g9L2s {
    width: 100%;
    overflow: hidden;
    background-position: 0px 0px;
    background-size: contain;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

    & img {
      width: 100%;
    }
  }
}

.mapStyle_KBva5 {
  position: absolute;
  bottom: 24px;
  right: 12px;
  height: 80px!important;
}

#geocoder_LYels {
  position: absolute;
  z-index: 1;
  width: 75%;
  left: 32px;
  top: 10px;
  height: fit-content;

  & .mapboxgl-ctrl-geocoder {
    width: 100%;
  }

  & input[type='text'] {
    padding-left: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/geotile/style.css"],"names":[],"mappings":"AAGA;CACC,iBAAiB;EAChB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;AACvE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;;EAEZ;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;;EAE5B;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,2BAA2B;IAC3B;;uBAEmB;;IAEnB;MACE,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,iBAAiB;MACjB,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,yDAAyD;;IAEzD;MACE,WAAW;IACb;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,SAAS;EACT,mBAAmB;;EAEnB;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import \"../../style/theme.css\";\n@import url( 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.css' );\n\n.content {\n position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  display:flex;\n  flex-direction:column;\n}\n\n.loader {\n  width: 100%;\n  height: 100%;\n}\n\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n}\n\n.mapSplit {\n  height: 100%;\n}\n\n.mapSplitLeft {\n  height: 100%;\n\n  & > div {\n    height : 100%;\n  }\n}\n\n.mapSplitRight {\n  background-color: #F4F6FA;\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.trash {\n  color : 'red';\n}\n\nsection.thumbnails {\n  display : grid;\n  grid: auto-flow dense / 1fr 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 32px;\n  padding: 32px;\n}\n\n.geotileThumbnail {\n  height: 200px;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 72px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  & .geotileThumbnailBottom {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 32px;\n    grid-template-rows: 1fr 1fr;\n    grid-template-areas: \n      \"title delete\"\n      \"subtitle delete\";\n\n    & .geotileThumbnailTitle {\n      grid-area: title;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n    & .geotileThumbnailSubtitle {\n      grid-area: subtitle;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n    & .delete {\n      grid-area: delete;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  & .thumbnailImage {\n    width: 100%;\n    overflow: hidden;\n    background-position: 0px 0px;\n    background-size: contain;\n    background-image: url('/assets/images/map-thumbnail.png');\n\n    & img {\n      width: 100%;\n    }\n  }\n}\n\n.mapStyle {\n  position: absolute;\n  bottom: 24px;\n  right: 12px;\n  height: 80px!important;\n}\n\n#geocoder {\n  position: absolute;\n  z-index: 1;\n  width: 75%;\n  left: 32px;\n  top: 10px;\n  height: fit-content;\n\n  & :global( .mapboxgl-ctrl-geocoder ) {\n    width: 100%;\n  }\n\n  & input[type='text'] {\n    padding-left: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_IpLxh`,
	"loader": `loader_qpzHn`,
	"header": `header_jNXcE`,
	"mapSplit": `mapSplit_kIzBD`,
	"mapSplitLeft": `mapSplitLeft_LBV3z`,
	"mapSplitRight": `mapSplitRight_AXsRw`,
	"trash": `trash_nDGai`,
	"thumbnails": `thumbnails_P2q59`,
	"geotileThumbnail": `geotileThumbnail_hw_L1`,
	"geotileThumbnailBottom": `geotileThumbnailBottom_tMibk`,
	"geotileThumbnailTitle": `geotileThumbnailTitle_WBOoI`,
	"geotileThumbnailSubtitle": `geotileThumbnailSubtitle_uQBcE`,
	"delete": `delete_UjMEt`,
	"thumbnailImage": `thumbnailImage_g9L2s`,
	"mapStyle": `mapStyle_KBva5`,
	"geocoder": `geocoder_LYels`
};
export default ___CSS_LOADER_EXPORT___;
